import { doc, getDoc, getDocFromServer } from "firebase/firestore";
import { db } from "../../firebase";
import { GetServiceOpts, EntityGet, EntityServerGet } from "../../types";
import { Llm } from "./types";
import { transformMetadata, processTimestampFields } from "../../utils";

export type LlmGetService<T> = (
  agentId: string,
  id: string,
  opts?: GetServiceOpts
) => Promise<T | null>;

const get: LlmGetService<EntityGet<Llm>> = async (agentId, id, opts = {}) => {
  const docRef = doc(db, `/agent/${agentId}/llm/${id}`);
  const { disableCache } = opts;
  const getFn = disableCache ? getDocFromServer : getDoc;
  const docSnap = await getFn(docRef);
  if (docSnap.exists()) {
    return processTimestampFields(
      transformMetadata({
        ...docSnap.data(),
        id: docSnap.id,
      } as EntityServerGet<Llm>)
    ) as EntityGet<Llm>;
  }
  return null;
};

export default get;
